import { render, staticRenderFns } from "./DocumentOverview.vue?vue&type=template&id=ef718138&"
import script from "./DocumentOverview.vue?vue&type=script&lang=ts&"
export * from "./DocumentOverview.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports